import { useState, useEffect } from "react";
import Void from "./void";

function LoadingScreen({ onDone }) {
  const [phase, setPhase] = useState("in"); // "in" | "hold" | "out"

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("out"), 2200);
    const t2 = setTimeout(() => onDone(), 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "#04080f",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
      color: "#ddeeff",
      opacity: phase === "out" ? 0 : 1,
      transition: "opacity 0.6s ease-in-out",
      zIndex: 9999,
    }}>
      {/* Star field */}
      <div style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none" }}>
        {STARS.map((s, i) => (
          <div key={i} style={{
            position: "absolute",
            left: `${s.x}%`, top: `${s.y}%`,
            width: s.r, height: s.r,
            borderRadius: "50%",
            background: "#fff",
            opacity: s.o,
            animation: `twinkle ${s.d}s ease-in-out infinite`,
            animationDelay: `${s.delay}s`,
          }} />
        ))}
      </div>

      {/* Logo / title */}
      <div style={{
        position: "relative", textAlign: "center",
        animation: "logoIn 0.7s cubic-bezier(0.22,1,0.36,1) forwards",
      }}>
        <div style={{
          fontSize: 48, marginBottom: 6,
          filter: "drop-shadow(0 0 24px #00aaff) drop-shadow(0 0 8px #0055ff)",
          animation: "pulse 2s ease-in-out infinite",
        }}>
          🌌
        </div>
        <div style={{
          fontSize: 28, fontWeight: 900, letterSpacing: 6,
          color: "#00ccff",
          textShadow: "0 0 30px rgba(0,200,255,0.6), 0 0 8px rgba(0,200,255,0.4)",
          marginBottom: 4,
        }}>
          VOID GALAXY
        </div>
        <div style={{
          fontSize: 11, letterSpacing: 4, fontWeight: 600,
          color: "rgba(0,200,255,0.45)",
          textTransform: "uppercase",
          marginBottom: 36,
        }}>
          Deep Space Harvester
        </div>

        {/* Loading bar */}
        <div style={{
          width: 200, height: 2,
          background: "rgba(0,200,255,0.12)",
          borderRadius: 2,
          overflow: "hidden",
          margin: "0 auto",
        }}>
          <div style={{
            height: "100%",
            background: "linear-gradient(90deg, #0055ff, #00ccff)",
            borderRadius: 2,
            animation: "loadBar 2s ease-out forwards",
            boxShadow: "0 0 8px rgba(0,200,255,0.8)",
          }} />
        </div>
        <div style={{
          marginTop: 12, fontSize: 10, letterSpacing: 2,
          color: "rgba(0,200,255,0.3)", fontWeight: 600,
        }}>
          INITIALIZING SYSTEMS
        </div>
      </div>

      <style>{`
        @keyframes logoIn {
          from { opacity: 0; transform: translateY(16px) scale(0.95); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
        @keyframes pulse {
          0%, 100% { filter: drop-shadow(0 0 24px #00aaff) drop-shadow(0 0 8px #0055ff); }
          50%       { filter: drop-shadow(0 0 40px #00ccff) drop-shadow(0 0 16px #0088ff); }
        }
        @keyframes twinkle {
          0%, 100% { opacity: var(--o, 0.5); }
          50%       { opacity: 0.1; }
        }
        @keyframes loadBar {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </div>
  );
}

const STARS = Array.from({ length: 80 }, () => ({
  x: Math.random() * 100,
  y: Math.random() * 100,
  r: Math.random() < 0.2 ? 2 : 1,
  o: 0.2 + Math.random() * 0.6,
  d: 2 + Math.random() * 3,
  delay: Math.random() * 3,
}));

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App">
      <Void />
      {!loaded && <LoadingScreen onDone={() => setLoaded(true)} />}
    </div>
  );
}

export default App;
